import { render, staticRenderFns } from "./PublishingContractsSubCataloguesEditPanel.vue?vue&type=template&id=0df165ba"
import script from "./PublishingContractsSubCataloguesEditPanel.vue?vue&type=script&lang=js"
export * from "./PublishingContractsSubCataloguesEditPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports